import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { firstValueFrom } from 'rxjs';
import { environment } from '../../../../environments/environment';

export interface SalesStaffOption {
  id: string;
  employeeCode: string;
  firstName: string;
  lastName: string;
}

@Injectable({ providedIn: 'root' })
export class BookingCollaboratorService {
  private readonly http = inject(HttpClient);
  private readonly apiUrl = `${environment.apiUrl}/booking-collaborators`;

  async getActiveSalesStaff(): Promise<SalesStaffOption[]> {
    const response = await firstValueFrom(
      this.http.get<{ staff: SalesStaffOption[] }>(`${this.apiUrl}/sales-staff`, {
        withCredentials: true,
      }),
    );
    return response.staff;
  }

  async create(bookingId: string, collaboratorId: string): Promise<void> {
    await firstValueFrom(
      this.http.post(`${this.apiUrl}/${bookingId}`, { collaboratorId }, { withCredentials: true }),
    );
  }

  async update(bookingId: string, collaboratorId: string): Promise<void> {
    await firstValueFrom(
      this.http.put(`${this.apiUrl}/${bookingId}`, { collaboratorId }, { withCredentials: true }),
    );
  }

  async delete(bookingId: string): Promise<void> {
    await firstValueFrom(
      this.http.delete(`${this.apiUrl}/${bookingId}`, { withCredentials: true }),
    );
  }
}
